export default function(http) {
  return {
      queryByPage(data){
        return http.json({
          url: `/integral/rule/query`,
          data
        });
      },

      save(data) {
          return http.json({
              url: '/integral/rule/save',
              data
          })
      },
      getInfo(data) {
          return http.json({
              url: `/integral/rule/get?id=${data.id}`
          })
      },
      /**
       * 删除版本
       * @param data
       * @return {*}
       */
      remove(data) {
          return http.json({
              url: `/integral/rule/delete?id=${data[0].id}`,
              data
          })
      },

  };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/integralRule.js